import { forwardRef } from "react";
import Box from "@mui/material/Box";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import type { DraggableAttributes } from "@dnd-kit/core";

interface DragHandleProps {
  listeners?: SyntheticListenerMap;
  attributes?: DraggableAttributes;
  size?: "small" | "medium";
}

export const DragHandle = forwardRef<HTMLDivElement, DragHandleProps>(
  function DragHandle({ listeners, attributes, size = "small" }, ref) {
    return (
      <Box
        ref={ref}
        {...listeners}
        {...attributes}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "grab",
          color: "action.disabled",
          opacity: 0.5,
          transition: "opacity 0.2s, color 0.2s",
          "&:hover": {
            opacity: 1,
            color: "action.active",
          },
          "&:active": {
            cursor: "grabbing",
          },
        }}
      >
        <DragIndicatorIcon fontSize={size} />
      </Box>
    );
  },
);
